import { IPagedListAction } from "../../components/UI/Declarations";
import {
    buildRecordLifecyclePagedListActions,
    type RecordLifecycleConfirmKind,
} from "../../utils/navigation/recordLifecycleActions";
import { EntityLabels } from "../../utils/navigation/pageTitles";

export type SiteAdminConfirmKind = RecordLifecycleConfirmKind;

/** Trimmed site name for user-facing messages; falls back if blank. */
export function formatSiteToastLabel(siteName: string | undefined): string {
    const t = typeof siteName === "string" ? siteName.trim() : "";
    return t.length > 0 ? t : EntityLabels.site;
}

export function getSiteAdminActionSuccessMessage(
    kind: SiteAdminConfirmKind,
    siteName: string | undefined
): string {
    const label = formatSiteToastLabel(siteName);
    const successByKind: Record<SiteAdminConfirmKind, string> = {
        disable: `${label} disabled successfully!`,
        enable: `${label} enabled successfully!`,
        softDelete: `${label} deleted successfully!`,
        restore: `${label} restored successfully!`,
    };
    return successByKind[kind];
}

export type SiteRow = { id: string; siteName: string };

export function buildSiteAdminPagedListActions(
    openConfirm: (kind: SiteAdminConfirmKind, item: SiteRow) => void
): IPagedListAction[] {
    return buildRecordLifecyclePagedListActions<SiteRow>(openConfirm);
}
